import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";

import {
  routes as allRoutes,
} from "App/routes";

export function redirect(path) {
  const RedirectComponent = () => {
    const location = useLocation();
    const basePath = location.pathname.endsWith("/") ? location.pathname.slice(0, -1) : location.pathname;
    const newPath = `${ basePath }/${ path }`;

    return <Navigate to={newPath} replace />;
  };

  return { component: RedirectComponent };
}

export function renderChildren(props) {
  const { childRoutes, match, children } = props;
  const parentPath = match && match.path;

  return (
    <>
      {children}
      {childRoutes && childRoutes.length && childRoutes.length > 0 && <Routes>
        {createRoutes(childRoutes, parentPath)}
      </Routes>}
    </>
  );
}

function createRoutes(childRoutes, parentPath) {
  let routesToRender = [];
  childRoutes.forEach(route => {
    const Component = route.component || (route.indexRoute && route.indexRoute.component);
    if (!Component) {
      return;
    }
    let childRoutes = [];

    // add indexRoute as default child for current route with exact path matching
    if (route.component && route.indexRoute) {
      childRoutes.push({
        component: route.indexRoute.component,
        path: createAbsolutePfad("", ""),
        exact: true,
      });
    }
    // if children should be nested: add nested children as childRoutes to current route
    if (route.nestedChildren) {
      childRoutes = childRoutes.concat(route.childRoutes);
    } else if (route.childRoutes) { // otherwise, create independant routes from childRoutes at the same level as current route
      const independantRoutes = createRoutes(route.childRoutes, createAbsolutePfad(parentPath, route.path));
      routesToRender = routesToRender.concat(independantRoutes);
    }

    let path = createAbsolutePfad(parentPath, route.path);

    if (path === "/") {
      path = "/*"; // für router 6
    } else {
      path += "/*";
    }

    routesToRender.push(<Route
      key={path}
      path={path}
      exact={route.exact || !route.nestedChildren}
      element={<Component childRoutes={childRoutes} />}
      render={props => <Component {...props} childRoutes={childRoutes} />}
    />);
  });
  return routesToRender;
}

function createAbsolutePfad(parent, pfad1) {
  parent = parent || "";
  const PATH = `${ parent }/${ pfad1 }`;
  return PATH.replace("///", "/").replace("//", "/");
}


export const flatAppPaths = routesToParams(allRoutes, "");

function routesToParams(routes, parentPath) {
  return routes.flatMap(route => {
    const absolutePath = createAbsolutePfad(parentPath, route.path);
    const childPaths = route.childRoutes ? routesToParams(route.childRoutes, absolutePath) : [];
    return [absolutePath].concat(childPaths);
  });
}

export function withLocation(Component) {
  return function ComponentWithRouter(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    const history = {
      push: (path, state) => navigate(path, { state }),
      replace: (path, state) => navigate(path, { replace: true, state }),
      location,
    };

    return (
      <Component
        {...props}
        location={location}
        navigate={navigate}
        params={params}
        history={history}
      />
    );
  };
}
